import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSocket } from "src/socket/useSocket";
import { useAuthStore } from "stores/authStore";

export const useTypingMessagesSocket = () => {
  const { t } = useTranslation("discussions");
  const currentUserId = useAuthStore(state => state.currentUserId);
  const socket = useSocket();
  const [typingMessages, setTypingMessages] = useState<Record<string, string>>(
    {}
  );

  useEffect(() => {
    if (!socket || !currentUserId) return;

    const handleTyping = ({
      discussionId,
      typing,
      userId,
      userName,
    }: {
      discussionId: string;
      typing: boolean;
      userId: string;
      userName?: string;
    }) => {
      if (currentUserId === userId) return;
      setTypingMessages(prev => ({
        ...prev,
        [discussionId]: typing
          ? `${userName ?? ""} ${t("typing").toLowerCase()}`.trim()
          : "",
      }));
    };

    socket.on("typing", handleTyping);
    return () => {
      socket.off("typing", handleTyping);
    };
  }, [socket, currentUserId, t]);

  return typingMessages;
};
